export const DEFAULT_LOCALE = 'ja';
export const LOCALE_LIST = ['en', 'ja', 'ko', 'zh', 'zt'];

// 兼容 lang 参数的全称写法（大小写不敏感），映射到内部短代码
export const LOCALE_ALIAS: Record<string, string> = {
  english: 'en',
  japanese: 'ja',
  korean: 'ko',
  chinese: 'zh',
  chinese_t: 'zt'
};
